<div>
  <app-post [clip]="clip"></app-post>
</div>
